/* eslint-disable no-nested-ternary */
import React from 'react';
export const ConditionalWrapper = ({ condition, wrapper, children, otherwise, }) => condition
    ? React.cloneElement(wrapper(children))
    : otherwise
        ? React.cloneElement(otherwise(children))
        : children;
